export default "__VITE_ASSET__BOaNsuKC__"